import { render, staticRenderFns } from "./StatementTags.vue?vue&type=template&id=3a728425&"
import script from "./StatementTags.vue?vue&type=script&lang=js&"
export * from "./StatementTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports